'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _reactFulcrum = require('@upgrowth/react-fulcrum');

var _layouts = require('./layouts');

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = (0, _reactRouterDom.withRouter)(function (_ref) {
  var match = _ref.match,
      _ref$layout = _ref.layout,
      layout = _ref$layout === undefined ? {} : _ref$layout,
      values = _ref.values,
      addOptions = _ref.addOptions,
      onRemove = _ref.onRemove,
      onReorder = _ref.onReorder;
  var _layout$order = layout.order,
      order = _layout$order === undefined ? [] : _layout$order,
      _layout$redirect = layout.redirect,
      redirect = _layout$redirect === undefined ? false : _layout$redirect,
      _layout$variant = layout.variant,
      variant = _layout$variant === undefined ? "secondary" : _layout$variant;
  var path = match.path,
      url = match.url;
  var orderedChildren = (0, _layouts.orderChildren)(values, order);
  var firstValue = (0, _lodash.first)(values);
  return _react2.default.createElement('div', {
    className: 'PagesLayout'
  }, _react2.default.createElement(_reactFulcrum.Sidebar, null, _react2.default.createElement(_reactFulcrum.NavMenu, {
    variant: variant
  }, addOptions, (0, _lodash.map)(orderedChildren, function (_ref2) {
    var key = _ref2.key,
        type = _ref2.type,
        dirty = _ref2.dirty,
        label = _ref2.label;
    return _react2.default.createElement(_reactFulcrum.NavItem, {
      as: _reactRouterDom.NavLink,
      to: url + '/' + key,
      key: key
    }, label, ' ', dirty && "!");
  }))), _react2.default.createElement('div', {
    className: 'pages-content'
  }, _react2.default.createElement(_reactRouterDom.Switch, null, _react2.default.createElement(_reactRouterDom.Route, {
    path: path + '/:active',
    render: function render(_ref3) {
      var active = _ref3.match.params.active;
      var activeValue = (0, _lodash.find)(values, function (_ref4) {
        var key = _ref4.key;
        return key == active;
      }); // Note, == comparison is intentional, sometimes keys are numbers

      if (!activeValue) {
        return null;
      }

      return activeValue.el;
    }
  }), redirect && firstValue && _react2.default.createElement(_reactRouterDom.Redirect, {
    to: path + '/' + firstValue.key
  }), _react2.default.createElement(_reactRouterDom.Route, null, _react2.default.createElement('div', {
    className: 'placeholder'
  }, _react2.default.createElement('h3', null, 'Choose a page'))))));
});